





















































import { Component, Prop, Vue } from 'vue-property-decorator'
import { State, Action, namespace } from 'vuex-class'

import sloganConfig from './SloganConfig'
import myUpload from '../../../components/crop/upload-2.vue'
import { oss } from '@/api/common/oss'

import { Account } from 'ykd-base/account'
import { rmSchema } from '@/apps/ice/utils/rm_schema'
import Drawer from './components/MobileDrawer.vue'

const accountUser = namespace('app-ice/account')

@Component({
  components: {
    myUpload,
    Drawer
  }
})
export default class Banner extends Vue {
  @Prop()
  change: any

  @accountUser.State('account')
  account!: Account
  @accountUser.Action('fetchAccount')
  fetchAccount!: () => void

  public async mounted() {
    await this.fetchAccount()
  }

  private visible: boolean = false
  private editMobile() {
    this.visible = true
  }

  imgDataUrl: string = ''
  show = false
  params: any = {}

  async created() {
    let ossResult: any = await oss()
    this.params = {
      ...ossResult
    }
  }

  upload() {
    this.params = {
      key: `avatar/user/${this.account.id}/${new Date().getTime()}.png`,
      ...this.params
    }
    this.show = true
  }

  cropUploadSuccess(jsonData: any, field: any) {
    this.account.user.avatarUrl = 'https://style.youkeda.com/' + this.params.key

    this.change(this.account.user.avatarUrl)
  }

  private toEdit() {
    // window.location.href="/personal/user/edit";
    this.$router.push('/personal/user/edit')
  }

  get todaySlogan() {
    const slogan: string = sloganConfig[new Date().getDate() - 1].replace(
      '。',
      ''
    )
    const strList: string[] = slogan.split(/(——.*)/)
    return strList
  }

  get avatarStyle() {
    if (this.account.user.avatarUrl) {
      let avatar = this.account.user.avatarUrl
      if (
        avatar.indexOf('oss-cn-hangzhou.aliyuncs.com') !== -1 ||
        avatar.indexOf('youkeda.com') !== -1
      ) {
        avatar = `${avatar}?x-oss-process=image/resize,m_lfit,w_750`
      }
      return `background-color: #dbdbdb;background-image: url(${rmSchema(
        avatar
      )})`
    } else {
      const url: string = `https://dummyimage.com/750x750/#44d7b6/fff.jpg&text=avatar`
      return `background-color: #44d7b6;background-image: url(${rmSchema(
        url
      )});`
    }
  }
}
